//
//
//
//
//
//

export default {
    name: "Column",

    props: {
        cols: {
            type: [Number, String],
            default: null
        },

        xs: {
            type: [Number, String],
            default: null
        },

        sm: {
            type: [Number, String],
            default: null
        },

        md: {
            type: [Number, String],
            default: null
        },

        lg: {
            type: [Number, String],
            default: null
        },

        xl: {
            type: [Number, String],
            default: null
        },
    }
}
